var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeCloseWhite = function SvgEyeCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "m7.245 6.667 26.667 26.666m-5.834-5.407C25.824 29.141 23.276 30 20.578 30c-5.884 0-11.056-4.087-14.021-7.035-.783-.779-1.175-1.168-1.424-1.931-.177-.545-.177-1.523 0-2.068.25-.764.642-1.154 1.426-1.933 1.495-1.486 3.55-3.26 5.973-4.655m20.546 12.011a34 34 0 0 0 1.52-1.422l.005-.005c.781-.776 1.173-1.165 1.421-1.928.178-.544.178-1.523 0-2.067-.25-.764-.641-1.154-1.423-1.932C31.635 14.087 26.463 10 20.578 10q-.843.001-1.666.107M22.783 22.5a3.333 3.333 0 0 1-4.603-4.814"
  })));
};
export default SvgEyeCloseWhite;